import styled from "styled-components"

import { constrictedContainer } from "../../styles/globalStyle"

export const Footer = styled.section`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 60px 10px;

  background-color: ${props => props.theme.footer.bgColor};

  color: #fff;
  font-family: ${props => props.theme.fonts.primary};

  @media (max-width: ${props => props.theme.sizes.footer.mobile}px) {
    padding: 0 10px 20px;
  }
`

export const Section = styled.div`
  min-width: 128px;

  h3 {
    margin-bottom: 20px;

    font-size: 1.3125em;
    font-weight: 700;
  }

  li {
    font-size: 0.8em;
    line-height: 21px;
    list-style: none;
    text-transform: capitalize;
  }

  a {
    color: #fff;
    text-decoration: none;

    :hover {
      color: ${props => props.theme.colours.main};
    }
  }
`
export const SocialMediaIcon = styled.div`
  svg {
    width: 35px;
    height: 35px;
  }
  &:not(:last-child) {
    margin-right: 8px;
  }
`

export const SocialMediaLink = styled.a`
  svg {
    width: 35px;
    height: 35px;

    :hover {
      path {
        fill: ${props => props.theme.colours.main};
      }
    }
  }

  &:not(:last-child) {
    margin-right: 8px;
  }
`

export const Inner = styled.div`
  ${constrictedContainer}

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 60px 0 0 0;

  hr {
    width: 35%;
    border-color: ${props => props.theme.colours.main};
    margin: 50px auto;
  }

  @media (max-width: ${props => props.theme.sizes.footer.mobile}px) {
    position: relative;

    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    ${Section} {
      margin-bottom: 40px;
    }

    ${Section}:first-child {
      margin-top: 60px;
    }
  }
`

export const NavigationItems = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${props => props.theme.sizes.footer.mobile}px) {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 10px;
  }
  @media (max-width: ${props => props.theme.sizes.footer.large}px) {
    justify-content: space-around;
  }
`

export const SocialLinksSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 20px;

  @media (max-width: ${props => props.theme.sizes.footer.mobile}px) {
    padding-bottom: 30px;
  }
`

export const FooterLogo = styled.img`
  position: absolute;
  top: -30px;
  width: 140px;
  display: block;

  @media (min-width: ${props => props.theme.sizes.footer.mobile}px) {
    top: -50px;
    width: 180px;
  }
`

export const footerDisclaimer = styled.div`
  font-size: 0.8em;
  text-align: center;
`
